// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-0be9a2e0] {\n  border-collapse: collapse;\n}\nth[data-v-0be9a2e0], td[data-v-0be9a2e0] {\n  border: 1px solid #d7d5d5 !important;\n  padding: 5px 15px !important;\n}\n.verified-cell[data-v-0be9a2e0] {\n  color: #67C23A;\n  font-weight: 600;\n}\n.missed-cell[data-v-0be9a2e0] {\n  color: #ff2544;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
